import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$c = ".Badge_module_badge__c44e2b28{background-color:var(--st-background);border:1px solid var(--st-border);border-radius:var(--st-rounded-base);cursor:default;padding:var(--st-spacing-0_5) var(--st-spacing);width:fit-content}";
collectCss(css$c);
var modules_35eb8564 = {"badge":"Badge_module_badge__c44e2b28"};

export { css$c as css, modules_35eb8564 as default };
//# sourceMappingURL=Badge.module.css.mjs.map
